import { NotificationType } from "@wingspanhq/wingspan-api-sdk";
import { selectorActiveNotifications } from "./selectorActiveNotifications";
import {
  AnyNotificationContext,
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";

export interface NotificationWithGroup<
  C extends AnyNotificationContext = AnyNotificationContext
> extends WSNotificationResponse<C> {
  group: WSNotificationResponse<C>[];
}

const GROUPED_ALERTS = [
  NotificationHandleType.RequirementsAwaitingReviewPayee,
  NotificationHandleType.RequirementsCompletePayee,
  NotificationHandleType.RequirementsRejectedPayee,
  NotificationHandleType.RequirementsReRequestedPayee,
  NotificationHandleType.RequirementsApprovedPayee
];

export const selectorAlerts = (notifications: WSNotificationResponse[]) => {
  const result: NotificationWithGroup[] = [];
  const activeNotifications = selectorActiveNotifications(notifications);
  activeNotifications
    .filter(notification => notification.type === NotificationType.DISMISSABLE)
    .filter(
      // Hide tax document alerts for now https://linear.app/wingspan/issue/PLA-773/hide-tax-documents-notification-on-dashboard
      notification => notification.handle !== "TaxDocumentsNEC"
    )
    .forEach(notification => {
      if (
        GROUPED_ALERTS.includes(
          notification.handle as NotificationHandleType
        ) &&
        result.some(r => r.handle === notification.handle)
      ) {
        result
          .find(r => r.handle === notification.handle)
          ?.group.push(notification);
      } else {
        result.push({ ...notification, group: [notification] });
      }
    });

  return result;
};
